import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../css/ProfileEmpty.css';

const ProfileEmpty = () => {
  return (
    <div className="dashboard-page">
      <Container fluid className="px-4 py-4">
        {/* Header Section */}
        <div className="profile-header mb-4">
          <h1 className="welcome-title">Hi Jessy,</h1>
          <p className="welcome-subtitle">Welcome to Xtrafyl Dashboard</p>
        </div>

        {/* Verification Banner */}
        <Card className="verification-banner mb-4">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={9} md={8}>
                <div className="d-flex align-items-center gap-3">
                  <div className="banner-icon">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <rect width="32" height="32" rx="8" fill="#8B5CF6" fillOpacity="0.2"/>
                      <path d="M16 8V16M16 16V24M16 16H24M16 16H8" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="banner-text">
                    <h3 className="banner-title">Documents Submitted</h3>
                    <p className="banner-description">Your verification is under review. You'll be notified once approved.</p>
                  </div>
                </div>
              </Col>
              <Col lg={3} md={4} className="text-end">
                <div className="verification-badge">Verification Pending!</div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Stats Grid */}
        <Row className="g-3 mb-4">
          <Col lg={3} md={6} sm={6}>
            <Card className="stat-card stat-card-purple">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                  <div className="stat-content">
                    <p className="stat-label">Total Earnings</p>
                    <h2 className="stat-value">$0</h2>
                  </div>
                  <div className="stat-icon stat-icon-purple">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="#8B5CF6"/>
                    </svg>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} sm={6}>
            <Card className="stat-card stat-card-pink">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                  <div className="stat-content">
                    <p className="stat-label">Completed Bookings</p>
                    <h2 className="stat-value">0</h2>
                  </div>
                  <div className="stat-icon stat-icon-pink">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="#EC4899"/>
                    </svg>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} sm={6}>
            <Card className="stat-card stat-card-orange">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                  <div className="stat-content">
                    <p className="stat-label">Active Bookings</p>
                    <h2 className="stat-value">0</h2>
                  </div>
                  <div className="stat-icon stat-icon-orange">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#F59E0B"/>
                    </svg>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} sm={6}>
            <Card className="stat-card stat-card-green">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                  <div className="stat-content">
                    <p className="stat-label">Customer Rating</p>
                    <h2 className="stat-value">0</h2>
                  </div>
                  <div className="stat-icon stat-icon-green">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="#10B981"/>
                    </svg>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Action Cards */}
        <Row className="g-3 mb-4">
          <Col lg={4} md={6}>
            <Card className="action-card">
              <Card.Body>
                <div className="action-card-header">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="action-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill="#1F2937"/>
                      </svg>
                    </div>
                    <h3 className="action-title">Add Services</h3>
                  </div>
                  <span className="action-badge">Pending</span>
                </div>
                <p className="action-description">
                  List the services you offer and set pricing for each category to start receiving orders
                </p>
                <button className="action-button">ADD SERVICES</button>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4} md={6}>
            <Card className="action-card">
              <Card.Body>
                <div className="action-card-header">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="action-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" fill="#1F2937"/>
                      </svg>
                    </div>
                    <h3 className="action-title">Add Drivers</h3>
                  </div>
                  <span className="action-badge">Pending</span>
                </div>
                <p className="action-description">
                  Invite drivers or team members to handle the incoming service requests in your area
                </p>
                <button className="action-button">ADD DRIVERS</button>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4} md={6}>
            <Card className="action-card">
              <Card.Body>
                <div className="action-card-header">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="action-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#1F2937"/>
                      </svg>
                    </div>
                    <h3 className="action-title">Set Bank Details</h3>
                  </div>
                  <span className="action-badge">Pending</span>
                </div>
                <p className="action-description">
                  Add your payout information to receive automatic weekly settlements for completed jobs.
                </p>
                <button className="action-button">ADD BANK ACCOUNT</button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Info Sections */}
        <Row className="g-3">
          <Col lg={4} md={6}>
            <Card className="info-card">
              <Card.Body>
                <div className="info-header">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="info-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill="#1F2937"/>
                      </svg>
                    </div>
                    <h3 className="info-title">Sales Overview</h3>
                  </div>
                </div>
                <div className="info-empty-state">
                  <p className="empty-state-text">
                    Your booking performance will appear here once you start receiving orders
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4} md={6}>
            <Card className="info-card">
              <Card.Body>
                <div className="info-header">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="info-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#1F2937"/>
                      </svg>
                    </div>
                    <h3 className="info-title">Most Used Services</h3>
                  </div>
                </div>
                <div className="info-empty-state">
                  <p className="empty-state-text">
                    No active most used services yet, Services provided it will showcase here
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4} md={6}>
            <Card className="info-card">
              <Card.Body>
                <div className="info-header">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="info-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19 4H5C3.89 4 3.01 4.9 3.01 6L3 18C3 19.1 3.89 20 5 20H19C20.11 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM19 18H5V8H19V18ZM7 10H9V16H7V10ZM11 10H13V16H11V10ZM15 10H17V16H15V10Z" fill="#1F2937"/>
                      </svg>
                    </div>
                    <h3 className="info-title">Recent Bookings</h3>
                  </div>
                </div>
                <div className="info-empty-state">
                  <p className="empty-state-text">
                    Your recent bookings will showcase here
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProfileEmpty;